"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_PlanDefinition_Goal = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_RelatedArtifact_1 = require("./RTTI_RelatedArtifact");
var RTTI_PlanDefinition_Target_1 = require("./RTTI_PlanDefinition_Target");
exports.RTTI_PlanDefinition_Goal = t.recursion('IPlanDefinition_Goal', function () {
    return t.intersection([
        t.type({
            description: RTTI_CodeableConcept_1.RTTI_CodeableConcept
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            category: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            priority: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            start: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            addresses: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            documentation: t.array(RTTI_RelatedArtifact_1.RTTI_RelatedArtifact),
            target: t.array(RTTI_PlanDefinition_Target_1.RTTI_PlanDefinition_Target)
        })
    ]);
});
//# sourceMappingURL=RTTI_PlanDefinition_Goal.js.map